"use strict";
var TouchAjaxinate = function (e) {
  var i = e || {},
        n = { pagination: ".AjaxinatePagination", method: "touchmove", container: ".AjaxinateLoop", offset: 0, loadingText: "Loading...", callback: null };
    (this.settings = Object.assign(n, i)),
        (this.addTouchMoveListeners = this.addTouchMoveListeners.bind(this)),
        (this.addClickListener = this.addClickListener.bind(this)),
        (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
        (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
        (this.destroy = this.destroy.bind(this)),
        (this.containerElement = document.querySelector(this.settings.container)),
        (this.paginationElement = document.querySelector(this.settings.pagination)),
        this.initialize();
};
(TouchAjaxinate.prototype.initialize = function () {
    if (this.containerElement) {
        var e = { click: this.addClickListener, touchmove: this.addTouchMoveListeners };
        e[this.settings.method]();
    }
}),
    (TouchAjaxinate.prototype.addTouchMoveListeners = function () {
        this.paginationElement &&
            (document.addEventListener("touchmove", this.checkIfPaginationInView), window.addEventListener("resize", this.checkIfPaginationInView), window.addEventListener("orientationchange", this.checkIfPaginationInView));
    }),
  (TouchAjaxinate.prototype.addClickListener = function () {
        this.paginationElement &&
            ((this.nextPageLinkElement = this.paginationElement.querySelector("a")), (this.clickActive = !0), this.nextPageLinkElement !== null && this.nextPageLinkElement.addEventListener("touchmove", this.stopMultipleClicks));
    }),
    (TouchAjaxinate.prototype.stopMultipleClicks = function (e) {
        e.preventDefault(), this.clickActive && ((this.nextPageLinkElement.innerHTML = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), (this.clickActive = !1), this.loadMore());
    }),
    (TouchAjaxinate.prototype.checkIfPaginationInView = function () {
        var e = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
            i = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
        e <= window.innerHeight &&
            i >= 0 &&
            ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
            this.removeScrollListener(),
            this.nextPageLinkElement && ((this.nextPageLinkElement.innerHTML = this.settings.loadingText), (this.nextPageUrl = this.nextPageLinkElement.href), this.loadMore()));
    }),
    (TouchAjaxinate.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
                if (this.request.readyState === 4 && this.request.status === 200) {
                    var i = this.request.responseXML.querySelectorAll(this.settings.container)[0],
                        n = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
                    this.containerElement.insertAdjacentHTML("beforeend", i.innerHTML),
                        (this.paginationElement.innerHTML = n.innerHTML),
                        this.settings.callback && typeof this.settings.callback == "function" && this.settings.callback(this.request.responseXML),
                        this.initialize();
                    			var maxColFourHegSize= 0,maxColSixHegSize = 0
                                var screenWidth = $(window).width();
                               $("#AjaxinateLoop .col-lg-4 .article_metadata").each(function(){
                                 $(this).removeAttr("style");
                                 if(screenWidth > 991){
                                   let h = $(this).innerHeight();
                                   if(maxColFourHegSize < h){
                                     maxColFourHegSize = h
                                   }
                                 }
                               });
                               $("#AjaxinateLoop .col-lg-6 .article_metadata").each(function(){
                                 $(this).removeAttr("style");
                                 if(screenWidth > 991){
                                   let h = $(this).innerHeight();
                                   if(maxColSixHegSize < h){
                                     maxColSixHegSize = h
                                   }
                                 }
                               });
                               if(screenWidth > 991){
                                 $("#AjaxinateLoop .col-lg-4 .article_metadata").attr("style","height:"+ maxColFourHegSize + "px;");
                                 $("#AjaxinateLoop .col-lg-6 .article_metadata").attr("style","height:"+ maxColSixHegSize + "px;");
                               }
                                    }
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl),
            (this.request.responseType = "document"),
            this.request.send();
  			
    }),
    (TouchAjaxinate.prototype.removeClickListener = function () {
        this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }),
    (TouchAjaxinate.prototype.removeScrollListener = function () {
        document.removeEventListener("touchmove", this.checkIfPaginationInView), window.removeEventListener("resize", this.checkIfPaginationInView), window.removeEventListener("orientationchange", this.checkIfPaginationInView);
    }),
    (TouchAjaxinate.prototype.destroy = function () {
        var e = { click: this.removeClickListener, touchmove: this.removeScrollListener };
        return e[this.settings.method](), this;
    });